import { render, staticRenderFns } from "./MyPlans-company.vue?vue&type=template&id=69c79371&scoped=true"
import script from "./MyPlans-company.vue?vue&type=script&lang=js"
export * from "./MyPlans-company.vue?vue&type=script&lang=js"
import style0 from "./MyPlans-company.vue?vue&type=style&index=0&id=69c79371&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c79371",
  null
  
)

export default component.exports